.wrapper {
  margin-bottom: 16px;
  display: flex;
  flex-flow: row wrap;
}
.wrapper .element {
  flex: 1 auto;
  margin: 2px;
  padding: 10px;
  height: var(--clickable-height);
  min-height: var(--clickable-height);
  line-height: 28px;
  cursor: pointer;
  border-radius: 4px;
  box-shadow: 1px 1px 2px #888;
  text-align: center;
}
.wrapper .element .contents {
  display: flex;
  flex-flow: row wrap;
}
.wrapper .element .contents .contentItem {
  flex: 1 auto;
}

:global(.dark) .wrapper .element {
  box-shadow: -1px -1px 2px #666;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZsZXhMaXN0LnNhc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNFO0VBQ0E7O0FBQ0E7RUFDRTs7O0FBRVI7RUFDRSIsInNvdXJjZXNDb250ZW50IjpbIi53cmFwcGVyXG4gIG1hcmdpbi1ib3R0b206IDE2cHhcbiAgZGlzcGxheTogZmxleFxuICBmbGV4LWZsb3c6IHJvdyB3cmFwXG4gIC5lbGVtZW50XG4gICAgZmxleDogMSBhdXRvXG4gICAgbWFyZ2luOiAycHhcbiAgICBwYWRkaW5nOiAxMHB4XG4gICAgaGVpZ2h0OiB2YXIoLS1jbGlja2FibGUtaGVpZ2h0KVxuICAgIG1pbi1oZWlnaHQ6IHZhcigtLWNsaWNrYWJsZS1oZWlnaHQpXG4gICAgbGluZS1oZWlnaHQ6IDI4cHhcbiAgICBjdXJzb3I6IHBvaW50ZXJcbiAgICBib3JkZXItcmFkaXVzOiA0cHhcbiAgICBib3gtc2hhZG93OiAxcHggMXB4IDJweCAjODg4XG4gICAgdGV4dC1hbGlnbjogY2VudGVyXG4gICAgLmNvbnRlbnRzXG4gICAgICBkaXNwbGF5OiBmbGV4XG4gICAgICBmbGV4LWZsb3c6IHJvdyB3cmFwXG4gICAgICAuY29udGVudEl0ZW1cbiAgICAgICAgZmxleDogMSBhdXRvXG5cbjpnbG9iYWwoLmRhcmspIC53cmFwcGVyIC5lbGVtZW50XG4gIGJveC1zaGFkb3c6IC0xcHggLTFweCAycHggIzY2NlxuIl19 */